import React from "react";
import "../assets/css/components/JobCardSkeleton.css";



const MyJobsSkeleton = () => {
  return (
    <div className="myjobs-skeleton-page">

      {/* Header */}
      <div className="myjobs-sk-header">
        <div className="sk-circle shimmer"></div>
        <div className="sk-title shimmer"></div>
      </div>

      {/* Tabs */}
      <div className="myjobs-sk-tabs">
        {Array.from({ length: 7 }).map((_, i) => (
          <div className="sk-tab shimmer" key={i}></div>
        ))}
      </div>

      {/* Cards */}
      <div className="myjobs-sk-list">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="job-sk-card" key={index}>

            <div className="job-sk-top">
              <div className="job-sk-jobtitle shimmer"></div>
              <div className="job-sk-status shimmer"></div>
            </div>

            <div className="job-sk-meta">
              <div className="job-sk-chip shimmer"></div>
              <div className="job-sk-chip shimmer"></div>
              <div className="job-sk-chip shimmer"></div>
            </div>

            <div className="job-sk-line shimmer"></div>
            <div className="job-sk-line short shimmer"></div>

            <div className="job-sk-images">
              <div className="job-sk-image shimmer"></div>
              <div className="job-sk-image shimmer"></div>
              <div className="job-sk-image shimmer"></div>
            </div>

            <div className="job-sk-buttons">
              <div className="job-sk-btn shimmer"></div>
              <div className="job-sk-btn shimmer"></div>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
};

export default MyJobsSkeleton;